import { Link } from "react-router-dom";
import { Home, ArrowLeft, Search } from "lucide-react";
import { Button } from "@/components/ui/button";
import { BrandIcon, Wordmark } from "@/components/Brand";

// עמוד 404 מותג בעברית (RTL) — תואם לעיצוב האתר.
export default function PageNotFound() {
  return (
    <div dir="rtl" className="min-h-screen flex items-center justify-center p-6 bg-background relative overflow-hidden">
      {/* רקע מעוצב */}
      <div className="absolute top-0 left-1/4 w-[420px] h-[420px] rounded-full bg-primary/20 blur-[120px] -z-10" />
      <div className="absolute bottom-0 right-1/4 w-[360px] h-[360px] rounded-full bg-accent/20 blur-[100px] -z-10" />

      <div className="relative z-10 max-w-lg w-full text-center">
        <Link to="/" className="inline-flex items-center gap-2 mb-10">
          <BrandIcon size={40} className="rounded-xl shadow-lg shadow-primary/30" />
          <Wordmark className="text-2xl text-foreground" />
        </Link>

        <div className="font-heading font-extrabold leading-none text-7xl sm:text-8xl gradient-text bg-clip-text text-transparent bg-gradient-to-r from-primary to-purple-500">
          404
        </div>

        <h1 className="text-2xl sm:text-3xl font-heading font-extrabold text-foreground mt-6">
          אופס! הדף לא נמצא
        </h1>
        <p className="text-muted-foreground leading-relaxed mt-3 max-w-md mx-auto">
          אנחנו מתנצלים — הדף שחיפשתם לא קיים, הוסר או שהכתובת שגויה. בואו נחזיר אתכם למסלול.
        </p>

        <div className="flex flex-col sm:flex-row gap-3 justify-center mt-8">
          <Button asChild size="lg" className="rounded-full gradient-primary text-white shadow-lg shadow-primary/30 font-bold gap-2 w-full sm:w-auto"><Link to="/">
              <Home className="w-5 h-5" /> חזרה לדף הבית
            </Link></Button>
          <Button asChild size="lg" variant="outline" className="rounded-full font-bold gap-2 w-full sm:w-auto"><Link to="/contact/">
              <Search className="w-5 h-5" /> צריך עזרה? צרו קשר
              <ArrowLeft className="w-4 h-4" />
            </Link></Button>
        </div>
      </div>
    </div>
  );
}
